import { PublicClientApplication, type Configuration, LogLevel } from "@azure/msal-browser";

function requireEnv(key: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (value === undefined || value === "" || value.startsWith("PLACEHOLDER")) {
    throw new Error(`Missing required Vite env: ${key}`);
  }
  return value;
}

const clientId = requireEnv("VITE_ENTRA_CLIENT_ID");
const tenantId = requireEnv("VITE_ENTRA_TENANT_ID");

const config: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          // eslint-disable-next-line no-console
          console.error("[msal]", message);
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const msalInstance = new PublicClientApplication(config);

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};
